import { useNavigate } from 'react-router-dom';
import './index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useTranslation } from 'react-i18next';
import { ImageUrl } from 'src/constants/imagesConst';
import RegistrationForm from './registrationForm';
import axios from 'axios';
import ForgotPasswordModal from './forgotPasswordModal';
import CircularProgress from '@mui/material/CircularProgress';
import { useState } from 'react';
import { API_BASE_URL } from 'src/apiConfig';

/* LOGIN STRANA */
const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isRegistration, setIsRegistration] = useState(false);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);

  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleRegisterClick = () => {
    setIsRegistration(true);
  };

  const handleLoginClick = () => {
    setIsRegistration(false);
  };

  const handleSignIn = async (event) => {
    event.preventDefault();
    setError('');

    if (!username || !password) {
      const text = t('login.reqFields');
      setError(text);
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.post(`${API_BASE_URL}/api/auth.php`, {
        username,
        password
      });

      setIsLoading(false);
      if (response.data.success) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('active_modes', response.data.active_modes);
        navigate('/');
        window.location.reload();
      } else {
        setError(t('login.loginError'));
        console.error('Neuspešna prijava:', response.data.error);
      }
    } catch (error) {
      setIsLoading(false);
      setError(t('login.generalError'));
      console.error('Greška prilikom prijave:', error.message);
    }
  };

  const handleForgotPasswordSubmit = async (email) => {
    setIsLoading(true);
    setIsForgotPasswordOpen(false);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth.php`, {
        action: 'forgot_pass',
        email: email
      });

      setIsLoading(false);

      if (response.data.success) {
        setShowSuccessDialog(true);
      } else {
        setError(response.data.error || t('login.generalError'));
      }
    } catch (error) {
      setIsLoading(false);
      setError(t('login.generalError'));
    }
  };

  return (
    <div id="content">
      <div
        className={`container ${isRegistration ? 'active' : ''}`}
        id="container"
      >
        {isRegistration ? (
          <RegistrationForm setIsRegistration={setIsRegistration} />
        ) : (
          <div className="form-container sign-in">
            <form onSubmit={handleSignIn}>
              <h3 className="title"> {t('general.kengurFull')}</h3>
              <div className="social-icons">
                <img
                  width={100}
                  height={100}
                  src="/kengur2/assets/kengur.png"
                  alt="Avatar"
                  className="img-kengur"
                />
              </div>
              <h3>{t('login.signIn')}</h3>
              <input
                type="text"
                placeholder={t('login.username')}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <input
                type="password"
                placeholder={t('login.password')}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {error !== '' && <p className="error-message">{error}</p>}

              <div style={{ textAlign: 'right', marginBottom: '10px' }}>
                <button
                  type="button"
                  onClick={() => {
                    setIsForgotPasswordOpen(true);
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#007bff',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontSize: '8px'
                  }}
                >
                  {t('login.forgotPassword')}
                </button>
              </div>
              <button type="submit">{t('login.signInButton')}</button>
            </form>
          </div>
        )}
        <div className="toggle-container">
          <div className="toggle">
            <div className="toggle-panel toggle-left">
              <div className="social-icons">
                <img
                  width={100}
                  height={100}
                  src="/kengur2/assets/kengur.png"
                  alt="Avatar"
                  className="img-kengur"
                />
              </div>
              <h1>{t('login.welcomeBack')}</h1>
              <p>{t('login.welcomeBackText')}</p>
              <button
                //  className="hidden"
                id="login"
                onClick={handleLoginClick}
              >
                {t('login.signInButton')}
              </button>
            </div>
            <div className="toggle-panel toggle-right">
              <img
                width={250}
                height={200}
                src={ImageUrl.math}
                alt="Tree"
                className="img-tree"
              />
              <p>{t('login.noAccount')}</p>
              <button
                // className="hidden"
                id="register"
                onClick={handleRegisterClick}
              >
                {t('login.registerButton')}
              </button>
            </div>
          </div>
        </div>

        {/* Loading indikator - zamenjeno sa CircularProgress */}
        {isLoading && (
          <div className="loading-spinner">
            <CircularProgress color="primary" />
          </div>
        )}

        {/* Success dialog */}
        {showSuccessDialog && (
          <div className="dialog-overlay">
            <div className="dialog-content">
              <p>{t('login.resetEmailSent')}</p>
              <button onClick={() => setShowSuccessDialog(false)}>
                {t('dialog.close')}
              </button>
            </div>
          </div>
        )}

        {/* Forgot Password Modal */}
        {isForgotPasswordOpen && (
          <ForgotPasswordModal
            isOpen={isForgotPasswordOpen}
            onClose={() => setIsForgotPasswordOpen(false)}
            onSubmit={handleForgotPasswordSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default LoginForm;
